export const COMMUNITY_GUIDELINES_ACCEPTED = 'community_guidelines_accepted';
